<header class="header">
  <div class="main-container clearfix">
    <h1 class="logo">
      <ods-button routerLink="/home" variant="standalone" class="logo-img" aria-label="UPMC Vaccine Portal Home"></ods-button>
    </h1>
    <nav class="main-menu">
      @if (username && employeeId) {
        <ods-button
          routerLink="/home"
          routerLinkActive="active_home"
          [routerLinkActiveOptions]="{ exact: true }"
          variant="standalone"
          class="main-menu__link"
          (click)="goBack()"
          [attr.aria-label]="'Hello ' + username + 'return home'">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          <span class="main-menu__link-title" aria-hidden="true">Hello, {{ username }}</span>
        </ods-button>
      }
      @if (showAdmin) {
        <ods-button routerLink="/admin" routerLinkActive="active" variant="standalone" class="main-menu__link main-men__link__admin">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
          <span class="main-menu__link-title">ADMIN</span>
        </ods-button>
      }
      @if (employeeId) {
        <ods-button (click)="logout()" variant="standalone" class="main-menu__link">
          <i class="fa fa-sign-out" aria-hidden="true"></i>
          <span class="main-menu__link-title">LOG OUT</span>
        </ods-button>
      }
    </nav>
  </div>
</header>
